<ng-container *ngIf="!isLoading; else formSkeleton">
<kodit-racun-form-container
  [racunFormConfig]="racunFormConfig"
  [jeEditMode]="jeEditMode"
>
  <div dodatni-input class="p-flex-md-row gap-12">

    <div class="p-d-flex p-flex-row p-flex-wrap gap-12">
      <kodit-text-input-field
        class="flex-1-1-150"
        formCtrlId="broj-fiskalnog-isecka"
        formCtrlLabel="Broj fiskalnog isečka"
        [formCtrl]="fakturaForm.controls.brojFiskalnogIsecka"
        [isVertial]="false"
        formCtrlLabelWidth="150px"
      ></kodit-text-input-field>

      <kodit-field class="flex-1-1-150" fieldLabel="Broj ugovora" fieldLabelFor="broj-ugovora">
        <kodit-text-input
          formCtrlId="broj-ugovora"
          [formCtrl]="fakturaForm.controls.racunDto.get('brojUgovora')"
          [formCtrlClass]="{
            'p-invalid':
              fakturaForm.errors?.dodatniPodaci &&
              fakturaForm.controls.racunDto.get('brojUgovora').touched
          }"
        >
        </kodit-text-input>
      </kodit-field>

      <!-- <kodit-field fieldLabel="Interni broj za rutiranje" fieldLabelFor="interniBrojZaRutiranje">
        <kodit-text-input
          formCtrlId="interniBrojZaRutiranje"
          [formCtrl]="fakturaForm.controls.racunDto.get('interniBrojZaRutiranje')"
        >
        </kodit-text-input>
      </kodit-field> -->

      <kodit-field
        class="flex-1-1-150"
        fieldLabel="Broj narudžbenice/fakture/ponude"
        fieldLabelFor="broj-narudzbenice"
      >
        <kodit-text-input
          formCtrlId="broj-narudzbenice"
          [formCtrl]="fakturaForm.controls.racunDto.get('brojNarudzbenice')"
          [formCtrlClass]="{
            'p-invalid':
              fakturaForm.errors?.dodatniPodaci &&
              fakturaForm.controls.racunDto.get('brojNarudzbenice').touched
          }"
        >
        </kodit-text-input>
      </kodit-field>

      <kodit-field class="flex-1-1-150" fieldLabel="Broj tendera" fieldLabelFor="broj-tendera">
        <kodit-text-input
          formCtrlId="broj-tendera"
          [formCtrl]="fakturaForm.controls.racunDto.get('brojTendera')"
          [formCtrlClass]="{
            'p-invalid':
              fakturaForm.errors?.dodatniPodaci &&
              fakturaForm.controls.racunDto.get('brojTendera').touched
          }"
        >
        </kodit-text-input>
      </kodit-field>
    </div>

    <hr />

    <div class="p-d-flex p-flex-row p-flex-wrap gap-12">
      <kodit-field
        class="flex-1-1-100"
        fieldLabel="Datum narudžbenice"
        fieldLabelFor="datum-narudzbenice"
      >
        <kodit-calendar
          formCtrlId="datum-narudzbenice"
          [formCtrl]="fakturaForm.controls.racunDto.get('datumNarudzbenice')"
          class="flex-50"
        ></kodit-calendar>
      </kodit-field>

      <kodit-field class="flex-1-1-100" fieldLabel="Broj otpremnice" fieldLabelFor="broj-otpremnice">
        <kodit-text-input
          formCtrlId="broj-otpremnice"
          [formCtrl]="fakturaForm.controls.racunDto.get('brojOtpremnice')"
          class="flex-50"
        >
        </kodit-text-input>
      </kodit-field>

      <kodit-field fieldLabel="Prijemnice" fieldLabelFor="prijemnice">
        <kodit-eotpremnica-multiselect
          [otpremniceArray]="fakturaForm.controls.ePrijemnice"
          (selectedOtpremnice)="selectedPrijemnice($event)"
          [tipDokumentaOtpremnica]="tipPrijemnica"
          [racunId]="fakturaForm.controls.racunDto.value.id"
        ></kodit-eotpremnica-multiselect>
      </kodit-field>

      <kodit-field fieldLabel="Otpremnice" fieldLabelFor="otpremnice">
        <kodit-eotpremnica-multiselect
          [otpremniceArray]="fakturaForm.controls.eOtpremnice"
          (selectedOtpremnice)="selectedOtpremnice($event)"
          [tipDokumentaOtpremnica]="tipOtpremnica"
          [racunId]="fakturaForm.controls.racunDto.value.id"
        ></kodit-eotpremnica-multiselect>
      </kodit-field>

      <kodit-field
        class="flex-1-1-100"
        fieldLabel="Datum otpremnice"
        fieldLabelFor="datum-otpremnice"
      >
        <kodit-calendar
          formCtrlId="datum-otpremnice"
          [formCtrl]="fakturaForm.controls.racunDto.get('datumOtpremnice')"
          class="flex-50"
        ></kodit-calendar>
      </kodit-field>

      <kodit-field
        class="flex-1-1-100"
        fieldLabel="Ovlašćen za potpisivanje"
        fieldLabelFor="ovlasceno-lice"
      >
        <kodit-text-input
          formCtrlId="ovlasceno-lice"
          [formCtrl]="
            fakturaForm.controls.racunDto.get('imeOsobeOvlasceneZaPotpisivanje')
          "
          class="flex-50"
        >
        </kodit-text-input>
      </kodit-field>

      <kodit-field class="flex-auto-width" fieldLabel="Vozila" fieldLabelFor="vozila">
        <kodit-vozilo-multiselect class="component-width"
            [voziloFormArray]="fakturaForm.controls.vozila"
            (selectedVozila)="selectedVozila($event)"
        >
        </kodit-vozilo-multiselect>
      </kodit-field>
    </div>

    <hr />

    <div class="p-d-flex p-flex-row p-flex-wrap gap-12"><!-- style="width: 200px;" -->
      <kodit-field class="flex-1-1-150" fieldLabel="Šifra objekta" fieldLabelFor="sifra-objekta" >
        <kodit-text-input
          formCtrlId="sifra-objekta"
          [formCtrl]="fakturaForm.controls.racunDto.get('sifraObjekta')"
          class="flex-50"
        >
        </kodit-text-input>
      </kodit-field>
    </div>

    <div
      *ngIf="
        fakturaForm.errors?.dodatniPodaci &&
        (fakturaForm.controls.racunDto.get('brojUgovora').touched ||
          fakturaForm.controls.racunDto.get('brojNarudzbenice').touched ||
          fakturaForm.controls.racunDto.get('brojTendera').touched)
      "
      class="p-text-center"
    >
      <small class="p-invalid"
        >Obavezno je uneti jedno od polja: Broj ugovora ili Broj narudžbenice
        ili Broj tendera</small
      >
    </div>
  </div>
</kodit-racun-form-container>
</ng-container>

<ng-template #formSkeleton>
  <div class="faktura-skeleton">

    <!-- Podesavanja racuna -->
    <div class="fs-card">
      <div class="fs-row">
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
      </div>
    </div>

    <!-- Info o racunu + Podaci kupca -->
    <div class="p-grid">
      <div class="p-col-6">
        <div class="fs-card fs-card--tall">
          <div class="fs-card-title"></div>
          <div class="fs-divider"></div>
          <div class="fs-fields">
            <div class="fs-field" *ngFor="let f of skeletonFields">
              <div class="fs-label"></div>
              <div class="fs-input"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-6">
        <div class="fs-card fs-card--tall">
          <div class="fs-card-title"></div>
          <div class="fs-divider"></div>
          <div class="fs-fields">
            <div class="fs-autocomplete"></div>
            <div class="fs-info-row">
              <div class="fs-info-label"></div>
              <div class="fs-info-value"></div>
            </div>
            <div class="fs-info-row">
              <div class="fs-info-label fs-info-label--short"></div>
              <div class="fs-info-value fs-info-value--long"></div>
            </div>
            <div class="fs-info-row">
              <div class="fs-info-label"></div>
              <div class="fs-info-value fs-info-value--medium"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Stavke -->
    <div class="fs-card">
      <div class="fs-card-title"></div>
      <div class="fs-divider"></div>
      <div class="fs-table">
        <div class="fs-table-head">
          <div class="fs-th fs-th--wide"></div>
          <div class="fs-th"></div>
          <div class="fs-th"></div>
          <div class="fs-th"></div>
          <div class="fs-th fs-th--wide"></div>
          <div class="fs-th fs-th--narrow"></div>
        </div>
        <div class="fs-table-row" *ngFor="let r of skeletonRows">
          <div class="fs-td fs-td--wide"><div class="fs-bar"></div></div>
          <div class="fs-td"><div class="fs-bar"></div></div>
          <div class="fs-td"><div class="fs-bar"></div></div>
          <div class="fs-td"><div class="fs-bar"></div></div>
          <div class="fs-td fs-td--wide"><div class="fs-bar"></div></div>
          <div class="fs-td fs-td--narrow"><div class="fs-bar fs-bar--icon"></div></div>
        </div>
        <div class="fs-total-row">
          <div class="fs-total-label"></div>
          <div class="fs-total-value"></div>
        </div>
      </div>
    </div>

    <!-- Podaci za uplatu -->
    <div class="fs-card">
      <div class="fs-card-title"></div>
      <div class="fs-divider"></div>
      <div class="fs-row fs-row--wrap">
        <div class="fs-field-col" *ngFor="let f of skeletonRows">
          <div class="fs-field-label"></div>
          <div class="fs-input fs-input--wide"></div>
        </div>
      </div>
    </div>

    <!-- Napomene -->
    <div class="fs-card">
      <div class="fs-card-title"></div>
      <div class="fs-divider"></div>
      <div class="fs-textarea"></div>
      <div class="fs-textarea fs-textarea--short"></div>
    </div>

    <!-- Akcije -->
    <div class="fs-card fs-card--actions">
      <div class="fs-btn"></div>
      <div class="fs-btn fs-btn--primary"></div>
    </div>

  </div>
</ng-template>
